import { Packet } from "./Packet";
import { PacketType } from "./PacketType";

export const getDisconnectPacket = (
  token: string,
): Packet<PacketType.INBOUND_CLIENT_DISCONNECT> => {
  return {
    type: PacketType.INBOUND_CLIENT_DISCONNECT,
    token: token,
  };
};
export const getConnectionPacket = (
  token: string,
): Packet<PacketType.INBOUND_CLIENT_CONNECTION> => {
  return {
    type: PacketType.INBOUND_CLIENT_CONNECTION,
    token: token,
  };
};
